module.exports = __webpack_public_path__ + "img/VolumeHigh.1a38297e.svg";